import React, { useState } from "react";
import { PlusIcon, XMarkIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const SpeakerField = ({ speakers = [], onSpeakersChange }) => {
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [bulkImport, setBulkImport] = useState("");

  const addSpeaker = () => {
    onSpeakersChange([...speakers, ""]);
  };

  const removeSpeaker = (index) => {
    const newSpeakers = speakers.filter((_, i) => i !== index);
    onSpeakersChange(newSpeakers);
  };

  const updateSpeaker = (index, value) => {
    const newSpeakers = [...speakers];
    newSpeakers[index] = value;
    onSpeakersChange(newSpeakers);
  };

  const handleBulkImport = () => {
    if (bulkImport.trim()) {
      const newSpeakers = bulkImport
        .split("\n")
        .map(speaker => speaker.trim())
        .filter(speaker => speaker !== "");
      
      const uniqueSpeakers = [...new Set([...speakers.filter(s => s !== ""), ...newSpeakers])];
      onSpeakersChange(uniqueSpeakers);
      setBulkImport("");
      setShowBulkImport(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Individual Speaker Fields */}
      <div className="space-y-3">
        {speakers.map((speaker, index) => (
          <div key={index} className="flex items-center gap-3">
            <input
              type="text"
              value={speaker}
              onChange={(e) => updateSpeaker(index, e.target.value)}
              placeholder={`Speaker ${index + 1}`}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-zinc-900/15 focus:border-zinc-900"
            />
            {speakers.length > 1 && (
              <button
                type="button"
                onClick={() => removeSpeaker(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Bulk Import Section */}
      {showBulkImport && (
        <div className="bg-gray-50 rounded-lg p-4 border">
          <h5 className="text-sm font-medium text-gray-700 mb-2 flex items-center">
            <UserGroupIcon className="h-4 w-4 mr-2" />
            Bulk Import Speakers
          </h5>
          <textarea
            value={bulkImport}
            onChange={(e) => setBulkImport(e.target.value)}
            placeholder="Enter one speaker per line..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-zinc-900/15 focus:border-zinc-900 mb-3"
          />
          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleBulkImport}
              className="px-3 py-2 bg-zinc-900 text-white text-sm rounded-lg hover:bg-zinc-800 transition-colors"
            >
              Import Speakers
            </button>
            <button
              type="button"
              onClick={() => {
                setShowBulkImport(false);
                setBulkImport("");
              }}
              className="px-3 py-2 bg-white text-zinc-700 border border-gray-300 text-sm rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex gap-2">
        <button
          type="button"
          onClick={addSpeaker}
          className="flex items-center px-3 py-2 text-zinc-900 hover:text-zinc-700 text-sm font-medium"
        >
          <PlusIcon className="h-4 w-4 mr-1" />
          Add Speaker
        </button>
        
        {!showBulkImport && (
          <button
            type="button"
            onClick={() => setShowBulkImport(true)}
            className="flex items-center px-3 py-2 text-gray-600 hover:text-gray-700 text-sm font-medium"
          >
            <UserGroupIcon className="h-4 w-4 mr-1" />
            Bulk Import
          </button>
        )}
      </div>
    </div>
  );
};

export default SpeakerField;
